import {
    Box,
    Typography,
    useTheme,
    Divider,
    // Avatar,
    Stack,
    IconButton
} from "@mui/material";
import { useState, useContext } from "react";
import InfoDataGrid from "../../components/InfoDataGrid";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import HostProblemElement from "./HostProblemElement";
import { tokens } from "../../theme";
import { int2ip } from "../../utils/formatIpAddress";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';
import GroupIcon from '@mui/icons-material/Group';
import { Link } from "react-router-dom";
import {Context} from "../../index";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from '@mui/icons-material/Edit';
import HostPortElement from "./HostPortElement";
import HostEdit from "../HostEdit/HostEdit"


const HostComponent = ({ networkId, host, problem, hostDownlinks, hostPorts }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {store} = useContext(Context);
    const user = store.user

    const [openHostEdit, setOpenHostEdit] = useState(false);
    const handleCloseHostEdit = () => {
        // setConversationMenuAnchorEl(null);
        setOpenHostEdit(false);
    }

    const handleOpenHostEdit = () => {
        // setConversationMenuAnchorEl(null);
        setOpenHostEdit(true);
    }


    const columnsHostDownlinks = [
        {
            field: 'portparents',
            headerName: 'Port',
            flex: 1
        },
        {
            field: 'ip',
            headerName: 'Host',
            flex: 10,
            renderCell: ({ row: { ip, uplink, vendor } }) => {
                return (
                    int2ip(ip) + ':' + uplink + '(' + vendor +')'
                )
            }
        },
    ];

    return (
        <Stack
            sx={{
                width: "100%", flexGrow: 1, overflowY: "scroll" 
            }}
        >
            {/* MODAL Host edit */}
            <HostEdit
                host={host}
                open={openHostEdit}
                handleClose={handleCloseHostEdit}
            />

            <Box
                sx={{
                    width: "100%",
                    borderRadius: 1,
                }}
                p={2}
            >
                <Stack
                    direction="row"
                    alignItems={"center"}
                    justifyContent="space-between"
                >
                    
                    <Stack direction="row" spacing={2}>
                        {" "}
                        
                        {/* <Avatar
                            alt="S W"
                            src={"img"}
                            sx={{
                                position: "static"
                            }}
                        /> */}
                        
                        <Stack spacing={0.3}>
                            <Typography
                                variant="h4"
                                fontWeight="bold"
                                sx={{ color: colors.grey[100] }}
                            >
                                {int2ip(host.ip)} ({host.mac})
                            </Typography>
                            <Typography variant="caption">Vendor: {host.vendor}</Typography>
                            <Typography variant="caption">Model: {host.type}</Typography>
                            
                        </Stack>
                    </Stack>
                    <Stack spacing={2} alignItems={"top"} justifyContent={'end'}>
                        {user.allowed_functions.indexOf( 'v2_put_host' ) !== -1 && (
                            <IconButton onClick={() => {
                                handleOpenHostEdit()
                            }}>
                                <EditIcon />
                            </IconButton>
                        )}
                        {/* <Typography sx={{ fontWeight: 600 }} variant="caption">
                            { host.updated_on }
                        </Typography> */}
                    </Stack>
                    
                </Stack>
                <Divider />
                <Stack>
                    <Typography variant="caption">Zabbix name: {host.zbx_name}</Typography>
                    <Typography variant="caption">Description: {host.zbx_description ? host.zbx_description : "undefined"}</Typography>
                    <Typography variant="caption">Location: {host.zbx_location ? host.zbx_location : "undefined"}</Typography>
                    <Typography variant="caption">Coordinates: {host.zbx_location_lat ? host.zbx_location_lat : "undefined"}:{host.zbx_location_lon ? host.zbx_location_lon : "undefined"}</Typography>
                    <Divider />
                    <Typography variant="caption">uplink: {host.uplink}</Typography>
                    <Typography variant="caption">connect_to: <Link to={`/search/host/${host.network}/${host.ipparents}`}>{int2ip(host.ipparents)}:{host.portparents}</Link></Typography>
                </Stack>
                <Divider />
                <Stack m={"10px"} spacing={0.5}>
                    <Stack 
                        direction="row"
                        spacing={{ xs: 1, sm: 2 }}
                        useFlexGap
                        sx={{ flexWrap: 'wrap' }}
                    >
                        {problem.length === 0 
                            ?   <Typography
                                    fontStyle="italic"
                                    sx={{ color: colors.greenAccent[600] }}
                                >
                                    <CheckBoxIcon />
                                    No problems found with the host
                                </Typography>
                            : problem.map((el) => {
                                return <HostProblemElement 
                                    problem={el}
                                />;
                            })
                        }
                    </Stack>
                </Stack>
                <Divider />
                <Stack m={"10px"} spacing={0.5}>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <SettingsEthernetIcon />
                            {/* <Typography color={colors.greenAccent[500]} variant="h5">
                                Connections
                            </Typography> */}
                        </AccordionSummary>
                        <AccordionDetails>
                            <InfoDataGrid
                                        columns={columnsHostDownlinks}
                                        rows={hostDownlinks}
                                        // getRowId={getRowId}
                                    />
                         </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <GroupIcon />
                            {/* <Typography color={colors.greenAccent[500]} variant="h5">
                                Connection users
                            </Typography> */}
                        </AccordionSummary>
                        <AccordionDetails>
                            <Stack
                                direction="row"
                                spacing={{ xs: 1, sm: 2 }}
                                useFlexGap
                                sx={{ flexWrap: 'wrap' }}
                            >
                            {Object.entries(hostPorts).map( ([key, value]) => {
                                return  <HostPortElement
                                            port={key}
                                            el={value}
                                        />;
                            })}
                            </Stack>
                        </AccordionDetails>
                    </Accordion>
                </Stack>
            </Box>
        </Stack>
    );
};

export default HostComponent;